import { TeacherSalaryType } from '../types'

export const PAID_CANCEL_SALARY_LABEL = '% ЗП педагогу при платной отмене всего занятия'
export const PAID_CANCEL_SALARY_DESCRIPTION =
  'Процент от полной ЗП за занятие. Применяется только к группам с оплатой по занятиям при платной отмене всего занятия; личные отмены учеников рассчитываются по их тарифам.'
export const isValidPaidCancelSalaryPercent = (value: unknown) =>
  value !== '' && value !== null && value !== undefined &&
  Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= 100

export const TEACHER_SALARY_LABELS: Record<TeacherSalaryType, string> = {
  'per-lesson': 'Оплата за занятие',
  'per-duration': 'Оплата за длительность занятия',
  'per-student-hour': 'Оплата за человеко-часы',
  'per-attendee': 'Оплата за учащихся, пришедших на занятие',
  'per-group-student': 'Оплата за количество учащихся в группе',
}

export const isThresholdSalary = (type?: TeacherSalaryType) =>
  type === 'per-attendee' || type === 'per-group-student'

export const TEACHER_SALARY_DESCRIPTIONS: Record<TeacherSalaryType, string> = {
  'per-attendee': 'Доступно только для групп с оплатой по занятиям. Зарплата определяется по таблице и отметкам присутствия. При изменении отметок зарплата пересчитывается.',
  'per-group-student': 'Зарплата определяется по таблице и количеству учащихся в группе на момент первого отчёта о занятии. Изменение состава группы не меняет сохранённый расчёт.',
  'per-lesson':
    'Фиксированная сумма за занятие, даже если урок был короче или длиннее обычного. Пример: ставка 800 руб. — за урок и 40, и 80 минут будет 800 руб.',
  'per-duration':
    'Сумма задается за выбранную длительность и растет пропорционально, если занятие идет дольше. Пример: 600 руб. за 40 минут — за 80 минут будет 1200 руб.',
  'per-student-hour':
    'Зарплата зависит от числа учеников и длительности занятия: больше учеников и времени, больше выплата. Пример: 200 руб. за 1 человеко-час, 5 учеников и 1 час — это 1000 руб.',
}

export const TEACHER_SALARY_OPTIONS: Array<{
  value: TeacherSalaryType
  label: string
}> = [
  { value: 'per-lesson', label: TEACHER_SALARY_LABELS['per-lesson'] },
  { value: 'per-duration', label: TEACHER_SALARY_LABELS['per-duration'] },
  {
    value: 'per-student-hour',
    label: TEACHER_SALARY_LABELS['per-student-hour'],
  },
  { value: 'per-attendee', label: TEACHER_SALARY_LABELS['per-attendee'] },
  { value: 'per-group-student', label: TEACHER_SALARY_LABELS['per-group-student'] },
]

export const getTeacherSalaryTypeLabel = (
  type?: TeacherSalaryType | null,
) => {
  return type ? TEACHER_SALARY_LABELS[type] : null
}

export const getTeacherSalaryTooltip = (
  type?: TeacherSalaryType | null,
) => {
  return type ? TEACHER_SALARY_DESCRIPTIONS[type] : null
}

export const formatTeacherSalaryShort = ({
  type,
  salary,
  durationMinutes,
}: {
  type?: TeacherSalaryType | null
  salary?: number | null
  durationMinutes?: number | null
}) => {
  if (isThresholdSalary(type ?? undefined)) return 'По ставкам'
  if (salary === null || salary === undefined || !type) {
    return '-'
  }

  switch (type) {
    case 'per-lesson':
      return `${salary}/урок`
    case 'per-duration':
      return durationMinutes
        ? `${salary}/${durationMinutes} мин.`
        : `${salary}/мин.`
    case 'per-student-hour':
      return `${salary}/чел.-час`
    default:
      return '-'
  }
}

export interface TeacherStudentRateInput {
  count: string
  salary: string
}

export const isValidTeacherStudentRates = (rates: TeacherStudentRateInput[], thresholds = false) => {
  if (thresholds && !rates.length) return false
  let previous = -1
  const counts = new Set<number>()
  for (const rate of rates) {
    const count = Number(rate.count)
    if (rate.count === '' || !Number.isInteger(count) || count < 0 || count > 10000 || counts.has(count)
      || rate.salary === '' || !Number.isFinite(Number(rate.salary)) || Number(rate.salary) < 0 || Number(rate.salary) > 99999999.99) {
      return false
    }
    if (thresholds && count <= previous) return false
    previous = count
    counts.add(count)
  }
  return true
}
